import PrintBlock from "../base/Block";
import BlockHeading from "../base/Heading";
import BlockRowContent from "../base/RowContent";

export default function BankDetailsBlock() {
    return (
        <PrintBlock
            style={{ marginVertical: "10px", fontSize: "8px", marginTop: 0 }}
        >
            <BlockHeading
                englishTitle="Bank Details"
                arabicTitle="ﺗﻔﺎﺻﻴﻞ اﻟﺒﻨﻚ"
            />

            <BlockRowContent
                englishLabel="Account Name"
                arabicLabel="اسم الحساب"
                content="{{accountName}}"
                disableArabicContent
            />
            <BlockRowContent
                englishLabel="Account No"
                arabicLabel="رﻗﻢ اﻟﺤﺴﺎب"
                content="{{accountNo}}"
                disableArabicContent
            />
            <BlockRowContent
                englishLabel="IBAN"
                arabicLabel="اﻳﺒﺎن"
                content="{{iban}}"
                disableArabicContent
            />
            <BlockRowContent
                englishLabel="Swift Code / BIC"
                arabicLabel="ﺳﻮﻳﻔﺖ ﻛﻮد / ﺑﻴﻚ"
                content="{{swiftCode}}"
                disableArabicContent
            />
            <BlockRowContent
                englishLabel="Bank Name"
                arabicLabel="اﺳﻢ اﻟﺒﻨﻚ"
                content="{{bankName}}"
                disableArabicContent
            />
            <BlockRowContent
                englishLabel="Bank Address"
                arabicLabel="ﻋﻨﻮان اﻟﺒﻨﻚ"
                content="{{bankAddress}}"
                disableArabicContent
            />
        </PrintBlock>
    );
}
